// web/src/console/sections/ErrorsSection.tsx
import type { JSX } from "react";
import { useState } from "react";
import { adminApi } from "../../lib/adminApi";
import { useConsole } from "../ConsoleContext";
import { useAsync } from "../useAsync";
import { LineChart, StatCard } from "../charts";
import { CardTitle } from "../Term";
import { fmtRelative, fmtCount } from "../format";

export function ErrorsSection(): JSX.Element {
  const { query, win, setWin, tick } = useConsole();
  const { data, loading, error, reload } = useAsync(
    () => adminApi.errors({ range: query.range, ...(query.from !== undefined && query.to !== undefined ? { from: query.from, to: query.to } : {}) }),
    [query.range, query.from, query.to, tick]
  );
  const [open, setOpen] = useState<number | null>(null);
  if (loading) return <div className="cc-skeleton" style={{ height: 220 }} />;
  if (error || !data) return <div className="cc-empty">加载失败。 <button className="cc-back" onClick={reload}>重试</button></div>;
  return (
    <>
      <div className="cc-grid-stats">
        <StatCard label="错误率" value={`${(data.errorRate * 100).toFixed(2)}%`} {...(data.errorRate > 0.02 ? { tone: "err" as const } : {})} />
        <StatCard label="错误（区间）" value={String(data.events.length)} />
      </div>
      <div className="cc-card" style={{ marginTop: 12 }}><CardTitle>错误率趋势</CardTitle>
        <LineChart
          points={data.series.map((s) => ({ ts: s.ts, value: s.count }))}
          stroke="var(--color-error)"
          from={data.window.from}
          to={data.window.to}
          formatY={fmtCount}
          onZoom={(f, t) => setWin({ from: f, to: t })}
        />
        {win !== null && (
          <button className="cc-back" style={{ marginTop: "var(--space-2)" }} onClick={() => setWin(null)}>重置时间范围</button>
        )}
      </div>
      <div className="cc-card" style={{ marginTop: 12 }}><CardTitle>最近错误</CardTitle>
        {data.events.length === 0 ? <div className="cc-empty">区间内无错误</div> : data.events.map((e) => (
          <div key={e.id}>
            <button className="cc-barchart-row" style={{ width: "100%", background: "none", border: "none", color: "inherit", cursor: "pointer", gridTemplateColumns: "60px 1fr 100px" }} onClick={() => setOpen(open === e.id ? null : e.id)}>
              <span style={{ color: "var(--color-error)" }}>{e.status ?? "ERR"}</span>
              <span style={{ textAlign: "left" }}>{e.method} {e.path}</span>
              <span>{fmtRelative(e.createdAt)}</span>
            </button>
            {open === e.id && <pre className="cc-card" style={{ whiteSpace: "pre-wrap", fontSize: "var(--text-caption)" }}>{e.message || "（无消息）"} — 操作者 {e.actor ?? "?"} / 租户 {e.tenant ?? "?"}</pre>}
          </div>
        ))}
      </div>
    </>
  );
}
